<template>
  <div>
    <div
      class="slider_container"
      @click="pauseOnInteractCheck"
      @mouseover="focusMode = true"
      @mouseleave="focusMode = false"
    >
      <slot
        :activeSlide="activeSlide"
        name="dots"
      />
      <div
        v-resize="slideResize"
        ref="slider"
        :class="{'slider_multi': transitionMode == 'multi'}"
        class="slider"
      >
        <div
          ref="rail"
          :class="{ 'e-break': transitioning == false,
                    'grabbed': grabMode == true,
                    'slider__rail_fade': transitionMode == 'fade' }"
          class="slider__rail"
          @mousedown="grabMode = true"
          @mouseup="grabMode = false"
        >
          <slot
            :activeSlide="activeSlide"
            name="slides"
          />
        </div>
      </div>
    </div>
    <div
      class="slider__navigation"
      role="navigation"
      aria-label="Carousel Navigator"
      @click="pauseOnInteractCheck"
      @mouseover="focusMode = true"
      @mouseleave="focusMode = false"
    >
      <button
        class="slider__navigation-btn left"
        @click="slideMove('left')"
      >
        <slot name="navigation__left"/>
        <span class="access-hidden">Navigate Left</span>
      </button>
      <button
        class="slider__pause-btn"
        @click="pauseMode = !pauseMode"
      >
        <slot name="navigation__pause"/>
        <span
          class="access-hidden"
          v-text="pauseMode ? 'Play' : 'Pause'"
        />
      </button>
      <button
        class="slider__navigation-btn right"
        @click="slideMove('right')"
      >
        <slot name="navigation__right"/>
        <span class="access-hidden">Navigate Right</span>
      </button>
    </div>
  </div>
</template>

<script>
import resize from 'vue-resize-directive'
import Hammer from 'hammerjs'

export default {
  name: 'GlobalCarousel',
  directives: {
    resize,
  },
  props: {
    autoChange: {
      type: Boolean,
      default: true,
    },
    autoChangeInterval: {
      type: Number,
      default: 7000,
    },
    disableAutoChangeMobile: {
      type: Boolean,
      default: false,
    },
    transitionMode: {
      type: String,
      default: 'slide',
    },
    pauseOnInteract: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSlide: 1,
      slideCount: null,
      transitioning: false,
      pauseMode: false,
      focusMode: false,
      grabMode: false,
      hammer: {},
    }
  },
  mounted() {
    const component = this
    let j = 0

    if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
      this.slideDuplicate()
      this.slideInitialActive()
    } else {
      this.slideCounter()
      this.$refs.rail.children[this.activeSlide - 1].classList.add('slide_active')
    }

    this.slideResize()

    if (this.autoChange === true) {
      this.sliderSetInterval()
    }

    this.hammer = new Hammer(this.$refs.slider)

    this.hammer.on('panleft', (ev) => {
      if (window.innerWidth >= 767) {
        if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
          component.$refs.rail.style.transition = 'left 0s cubic-bezier(0.215, 0.61, 0.355, 1)'
          j = ev.deltaX
          component.$refs.rail.style.left = `${j}px`
        }
      }
    })

    this.hammer.on('panright', (ev) => {
      if (window.innerWidth >= 767) {
        if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
          component.$refs.rail.style.transition = 'left 0s cubic-bezier(0.215, 0.61, 0.355, 1)'
          j = ev.deltaX
          component.$refs.rail.style.left = `${j}px`
        }
      }
    })

    this.hammer.on('panstart', () => {
      component.$refs.rail.style.cursor = '-webkit-grabbing'
    })

    this.hammer.on('swipeleft', () => {
      component.slideMove('right')
    })

    this.hammer.on('swiperight', () => {
      component.slideMove('left')
    })

    this.hammer.on('panend pancancel', () => {
      if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
        component.$refs.rail.style.transition = 'left 0.4s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.4s cubic-bezier(0.645, 0.045, 0.355, 1)'
        j = 0
        component.$refs.rail.style.left = `${j}px`
      }
      component.$refs.rail.style.cursor = '-webkit-grab'
    })
  },
  methods: {
    slideDuplicate() {
      const fakelist = this.$refs.slider.getElementsByClassName('slide')
      const slideList = []

      for (let i = 0; i < fakelist.length; i += 1) {
        slideList.push(fakelist[i])
      }

      this.slideCount = slideList.length

      slideList.forEach((el) => {
        const nodeClone = el.cloneNode(true)
        const links = nodeClone.getElementsByTagName('a')
        nodeClone.setAttribute('aria-hidden', 'true')
        for (let i = 0; i < links.length; i += 1) {
          links[i].setAttribute('tabIndex', '-1')
        }
        this.$refs.rail.appendChild(nodeClone)
      })

      const slideListReverse = slideList.reverse()

      slideListReverse.forEach((el) => {
        const nodeClone = el.cloneNode(true)
        const links = nodeClone.getElementsByTagName('a')
        nodeClone.setAttribute('aria-hidden', 'true')
        for (let i = 0; i < links.length; i += 1) {
          links[i].setAttribute('tabIndex', '-1')
        }
        this.$refs.rail.insertBefore(nodeClone, this.$refs.rail.childNodes[0])
      })
    },
    slideResize() {
      const fakelist = this.$refs.slider.getElementsByClassName('slide')
      const slideList = []

      for (let i = 0; i < fakelist.length; i += 1) {
        slideList.push(fakelist[i])
      }
      // End snippet

      // Get current height and width of the slider container
      const currentHeight = this.$refs.slider.offsetHeight
      const currentWidth = this.$refs.slider.offsetWidth

      // Apply that height and width to every slide in your slider
      for (const slide in slideList) { // eslint-disable-line no-restricted-syntax
        if (Object.prototype.hasOwnProperty.call(slideList, slide)) {
          slideList[slide].style.height = `${currentHeight}px`
          slideList[slide].style.width = `${currentWidth}px`
        }
      }

      // Set the slider rail width to facilitate the correct number of slides.
      // Not necessary for this example.

      // Initialize the starting position of the slider

      if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
        // Velocity(this.$refs.rail, { translateX: -currentWidth }, 0);
        // Velocity(this.$refs.rail, { translateX: -currentWidth * this.slideCount }, 0)
        this.$refs.rail.style.transform = `translateX(-${currentWidth * this.slideCount}px)`
      }
    },
    slideMove(i) {
      const theRail = this.$refs.rail
      const sliderWidth = theRail.parentNode.offsetWidth
      const direction = i
      let moveToSlide

      // This vue component comes with a
      // transitioning data flag set to false by default.

      // When the function starts, we check to make sure the flag
      // isnt true to prevent transition conflicts

      if (this.transitioning === false) {
        // Set the aforementioned flag to true
        // so the button can't be clicked again until the transition is done.

        if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
          this.transitioning = true
        }

        if (direction === 'right') {
          if (this.activeSlide === this.slideCount) {
            if (this.transitionMode === 'slide') {
              // Add Ghost
              this.$refs.rail.getElementsByClassName('slide_active')[0].nextSibling.classList.add('slide_active-ghost')
            }

            moveToSlide = this.activeSlide + 1
            this.activeSlide = 1
            this.slideKillActive(direction)
            this.slideInitialActive()
          } else {
            this.activeSlide += 1
            moveToSlide = this.activeSlide

            if (this.transitionMode === 'slide') {
              // Follow the currently active element
              this.$refs.rail.getElementsByClassName('slide_active')[0].nextSibling.classList.add('slide_active')
              this.slideKillActive(direction)
            }
          }
        } else if (direction === 'left') {
          if (this.activeSlide === 1) {
            if (this.transitionMode === 'slide') {
              // Add Ghost
              this.$refs.rail.getElementsByClassName('slide_active')[0].previousSibling.classList.add('slide_active-ghost')
            }

            moveToSlide = this.activeSlide - 1
            this.activeSlide = this.slideCount

            if (this.transitionMode === 'slide') {
              this.$refs.rail.getElementsByClassName('slide_active')[0].classList.remove('slide_active')
              this.$refs.rail.children[(this.slideCount + (this.slideCount - 1))].classList.add('slide_active')
            }
          } else {
            this.activeSlide -= 1
            moveToSlide = this.activeSlide

            // Follow the currently active element
            this.$refs.rail.getElementsByClassName('slide_active')[0].previousSibling.classList.add('slide_active')
            this.slideKillActive(direction)
          }
        }

        let newPosition

        if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
          newPosition = (sliderWidth * (moveToSlide + (this.slideCount - 1)))
        }

        if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
          this.slideMoveTransition(-newPosition)
        } else if (this.transitionMode === 'fade') {
          for (let m = 0; m < theRail.children.length; m += 1) {
            theRail.children[m].classList.remove('slide_active')
          }
          theRail.children[this.activeSlide - 1].classList.add('slide_active')
        }
      }
    },
    slideDotTrigger(i) {
      // This method is being used for explicit slide changes
      // using the dots. Some of what is here is a duplicate
      // of the stuff going on up to in slideMove.
      // This will be cleaned later

      const theRail = this.$refs.rail
      const sliderWidth = theRail.parentNode.offsetWidth
      const ghostsWidth = sliderWidth * (this.slideCount - 1)
      let newSlide

      // This vue component comes with a
      // transitioning data flag set to false by default.
      // When the function starts, we check to make sure the flag
      // isnt true to prevent transition conflicts

      if (this.transitioning === false) {
        this.transitioning = true
        this.activeSlide = i

        newSlide = this.activeSlide

        const newPosition = ghostsWidth + (sliderWidth * newSlide)

        if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
          this.slideMoveTransition(`-${newPosition}`)

          for (let m = 0; m < theRail.children.length; m += 1) {
            theRail.children[m].classList.remove('slide_active')
          }
          theRail.children[(this.activeSlide + this.slideCount) - 1].classList.add('slide_active')
        }
      }
    },
    slideTransitionEnd() {
      const component = this
      const theRail = this.$refs.rail
      const sliderWidth = theRail.parentNode.offsetWidth

      if (this.transitionMode === 'slide' || this.transitionMode === 'multi') {
        theRail.style.transitionDuration = '0s'
        if (component.activeSlide === 1) {
          theRail.style.transform = `translateX(-${(sliderWidth * (this.slideCount))}px)`
        } else if (component.activeSlide === component.slideCount) {
          theRail.style.transform = `translateX(-${(sliderWidth * (this.slideCount + (this.slideCount - 1)))}px)`
        }
        setTimeout(() => {
          theRail.style.removeProperty('transition-duration')
          component.transitioning = false
        }, 50)
      } else {
        component.transitioning = false
      }
    },
    slideCounter() {
      const fakelist = this.$refs.slider.getElementsByClassName('slide')
      const slideList = []

      for (let i = 0; i < fakelist.length; i += 1) {
        slideList.push(fakelist[i])
      }

      this.slideCount = slideList.length
    },
    sliderSetInterval() {
      const slider = this

      setInterval(() => {
        if (slider.disableAutoMobile === false
          && slider.focusMode === false
          && slider.pauseMode === false) {
          slider.slideMove('right')
        } else if (window.innerWidth >= 767
          && slider.focusMode === false
          && slider.pauseMode === false) {
          slider.slideMove('right')
        }
      }, slider.autoChangeInterval)
    },
    pauseOnInteractCheck() {
      if (this.pauseOnInteract === true) {
        this.pauseMode = true
      }
    },
    slideInitialActive() {
      if (this.transitionMode === 'slide') {
        this.$refs.rail.children[this.slideCount].classList.add('slide_active')
      }
    },
    slideKillActive(d) {
      if (d === 'right') {
        this.$refs.rail.getElementsByClassName('slide_active')[0].classList.remove('slide_active')
      } else if (d === 'left') {
        this.$refs.rail.getElementsByClassName('slide_active')[1].classList.remove('slide_active')
      }

      if (this.$refs.rail.getElementsByClassName('slide_active-ghost')[0]) {
        setTimeout(() => {
          this.$refs.rail.getElementsByClassName('slide_active-ghost')[0].classList.remove('slide_active-ghost')
        }, 400)
      }
    },
    slideMoveTransition(p) {
      this.$refs.rail.style.transform = `translateX(${p}px)`

      setTimeout(() => {
        this.slideTransitionEnd()
      }, 400)
    },
  },
}
</script>

<style lang="scss">
  /* ----------------------------- */

  /* SLIDER BASE STYLES (REUSABLE) */

  /* ----------------------------- */

  .slider_container {
    overflow: hidden;
  }

  .slider {
    position: relative;
    height: 510px;
    overflow: hidden;
  }

  .slider_multi {
    width: 33.333333%;
    overflow: visible;
  }

  .slider__rail {
    position: absolute;
    top: 0;
    height: 100%;
    font-size: 0;
    white-space: nowrap;
    cursor: grab;
    transition:
      left 0.4s cubic-bezier(0.645, 0.045, 0.355, 1),
      transform 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .slider__rail_fade {
    .slide {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      visibility: hidden;
      opacity: 0;
      transition: visibility 0.8s ease-in-out, opacity 0.8s ease-in-out;
    }

    .slide_active {
      visibility: visible;
      opacity: 1;
    }
  }

  .slide {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    white-space: normal;
    vertical-align: top;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .slider__navigation {
    font-size: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/GlobalCarousel.vue